import { render, staticRenderFns } from "./DashboardListItem.vue?vue&type=template&id=25f3a956&"
import script from "./DashboardListItem.vue?vue&type=script&lang=js&"
export * from "./DashboardListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DashboardListItem.vue"
export default component.exports